<phx-modal-confirm [phxOpen]="phxOpen" (phxOpenChange)="phxOpenChange.emit($event)" phxSize="small">
  <div phx-modal-header>
    <span phxModalTitle>{{ 'Customize Columns' | phxTranslate }}</span>
  </div>
  <div phx-modal-body>
    <p class="phx-web-type-body-small phx-table-column-customizer-hint">
      {{ 'Drag to reorder. Toggle visibility with the eye icon.' | phxTranslate }}
    </p>
    <phx-drop-list [(ngModel)]="items" [phxDragItemTemplate]="reorderItemTpl">
      <ng-template #reorderItemTpl let-item let-index="index">
        <phx-drag-item-inline [phxDragWithinParent]="true">
          <div class="phx-table-column-customizer-item">
            <span
              class="phx-web-type-body-medium phx-table-column-customizer-item-label"
              [style.opacity]="item.visible ? 1 : 0.5"
              >{{ item.label }}</span
            >
            <button
              phx-icon-button
              phxType="ghost"
              [phxIconButtonSize]="'extra-small'"
              [phxIcon]="item.visible ? EyeIcon : EyeDisabledIcon"
              (click)="$event.stopPropagation(); onToggleVisibility(item)"
            ></button>
          </div>
        </phx-drag-item-inline>
      </ng-template>
    </phx-drop-list>
  </div>
  <div phx-modal-footer>
    <button phx-button phxButtonRole="secondary" phxSize="small" (click)="onCancel()">
      {{ 'Cancel' | phxTranslate }}
    </button>
    <button phx-button phxButtonRole="primary" phxSize="small" (click)="onApply()">{{ 'Apply' | phxTranslate }}</button>
  </div>
</phx-modal-confirm>
